<template>
  <div class="container-fluid no-padding">
    <div class="row bg-primary-dark">
      <div class="col-md-8 mb-2 mt-2 align-middle">
        <h4>Ürün Fiyatları</h4>
      </div>
      <div class="col-md-4 mb-2 mt-2">
        <button role="button" class="btn btn-more-radius btn-success float-right" @click="selectPrice(-1)"
          data-toggle="modal" data-target="#trackNumberModal"  v-if="canSetPrice">Yeni Fiyat Oluştur</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <v-wait for="prices-loading">
          <template slot="waiting">
            <div class="vue-wait-class">
              <img src="static/loading.svg" />
              <p>Veriler yükleniyor...</p>
            </div>
          </template>
          <table class="table table-hover">
            <thead class="thead-light">
              <tr>
                <th style="width:20%;">ÜRÜN</th>
                <th style="width:10%" class="text-center">BAYİİ / ALICI</th>
                <th style="width:20%" class="text-center">BİRİM FİYAT</th>
                <th style="width:8%" class="text-center">TAAHHÜT ADEDİ</th>
                <th style="width:25%" class="text-center">FİYAT NOTU</th>
                <th style="width:8%" class="text-center">SON GÜNCELLEME</th>
                <th v-if="canSetPrice" class="text-center">İŞLEMLER</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(price, index) in prices" v-bind:key="'price'+price.PRICE_ID"> 
                <td class="align-middle">{{price.PRICE_NAME}}</td>
                <td class="text-center align-middle">{{price.RETAILER_NAME}}</td>
                <td class="text-center align-middle">
                  <div class="justify-content-between">
                    <p class="my-0">₺ {{price.PRICE_VALUE}}</p>
                    <small class="text-muted">KDV : ₺ {{calculateKDV(price.PRICE_VALUE)}}&nbsp;&nbsp;&bull;&nbsp;&nbsp;Toplam : ₺ {{calculateTotal(price.PRICE_VALUE)}}</small>
                  </div>
                </td>
                <td class="text-center align-middle">{{price.PRICE_RANGE}}</td>
                <td class="text-center align-middle">{{price.PRICE_NOTE}}</td>
                <td class="text-center align-middle">{{parseUpdated(price.PRICE_UPDATED)}}</td>
                <td v-if="canSetPrice" class="text-center align-middle">
                  <button class="btn btn-sm btn-more-radius btn-primary" data-toggle="modal" 
                    data-target="#trackNumberModal" @click="selectPrice(index)">Güncelle</button>
                  <button class="btn btn-sm btn-more-radius btn-danger" @click="deletePrice(index)">Sil</button>
                </td>
              </tr>
            </tbody>
          </table>
        </v-wait>
      </div>
    </div>
    <div v-if="canSetPrice" class="modal fade" id="trackNumberModal" tabindex="-1" role="dialog" aria-labelledby="trackNumberModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header bg-success">
            <h5 class="modal-title text-white" id="trackNumberModalLabel">Fiyat Güncelle</h5>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="text-white">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="price-updating">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Veriler yükleniyor...</p>
                </div>
              </template>
              <div class="form-group">
                <label for="price-name">Ürün / Set Adı</label>
                <input type="text" class="form-control" v-model="priceModel.PRICE_NAME" id="price-name">
              </div>
              <div class="form-group">
                <label for="price-name">Bayii / Alıcı</label>
                <select class="custom-select" id="price-retailer" v-model="priceModel.RETAILER_ID">
                  <option value="0" selected>Bayii seçiniz...</option>
                  <option value="1">LENOİ</option>
                  <option value="2">NOKKON</option>
                  <option value="3">ZİMİR</option>
                  <option value="4">İNTERGLOBAL</option>
                  <option value="5">BÜLENT EŞKİ</option>
                  <option value="6">AROMİL</option>
                  <option value="9">SECAN GÜVENLİK</option>
                  <option value="10">CANTEL ELEKTRONİK</option>
                  <option value="11">PTT</option>
                  <option value="13">ASİS ELEKTRONİK</option>
                  <option value="14">DCA</option>
                  <option value="15">NOKITECH</option>
                  <option value="16">FİLOSİSTEM</option>
                  <option value="17">SEZGİN KOÇ</option>
                  <option value="18">DİĞER</option>
                </select>
              </div>
              <div class="form-group">
                <label for="price-value">Birim Fiyat</label>
                <input type="text" class="form-control" v-model="priceModel.PRICE_VALUE" id="price-value">
              </div>
              <div class="form-group">
                <label for="price-range">Taahhüt Edilen Ürün Adedi</label>
                <input type="number" class="form-control" v-model="priceModel.PRICE_RANGE" id="price-range">
              </div>
              <div class="form-group">
                <label for="price-range">Taahhüt Edilen Ürün Adedi</label>
                <textarea rows="3" class="form-control" v-model="priceModel.PRICE_NOTE" id="price-note" />
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-more-radius btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="setPrice()" class="btn btn-more-radius btn-primary">Fiyatı Güncelle</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'SarfMalzemeleriPAge',
  components: {},
  data () {
    return {
      prices: [],
      priceModel: {
        SessionId: '',
        PRICE_ID: 0,
        PRICE_NAME: '',
        PRICE_VALUE: '',
        PRICE_RANGE: 0,
        PRICE_NOTE: '',
        RETAILER_ID: 0,
      },
      bckPriceModel: {
        SessionId: '',
        PRICE_ID: 0,
        PRICE_NAME: '',
        PRICE_VALUE: '',
        PRICE_RANGE: 0,
        PRICE_NOTE: '',
        RETAILER_ID: 0,
      }
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
    canSetPrice : function() { return this.$store.getters.userCanSetPrices }
  },
  methods: {
    getPrices() {
      this.$wait.start('prices-loading')
      axios.post('/api/stok/fiyatlar')
      .then(response => {
        this.prices = response.data
        this.$wait.end('prices-loading')
      })
      .catch(error => { 
        console.error(error) 
      })
    },
    setPrice() {
      this.$wait.start('price-updating')

      const newPrice = {
        ...this.priceModel,
        RETAILER_ID: parseInt(this.priceModel.RETAILER_ID),
        PRICE_ID: parseInt(this.priceModel.PRICE_ID),
        PRICE_RANGE: parseInt(this.priceModel.PRICE_RANGE),
      }

      axios.post('/api/stok/fiyat-guncelle', newPrice)
      .then(response => {
        this.$wait.end('price-updating')
        $("#trackNumberModal").modal('hide')
        this.getPrices()
      })
      .catch(error => { 
        console.error(error) 
      })
    },
    deletePrice(index) {
      this.selectPrice(index)
      this.$wait.start('price-updating')
      axios.post('/api/stok/fiyat-sil', this.priceModel)
      .then(response => {
        this.priceModel = this.bckPriceModel
        this.getPrices()
      })
      .catch(error => { 
        console.error(error) 
      })
    },
    selectPrice(index) {
      if(index > -1)
        this.priceModel = this.prices[index]
      else
        this.priceModel = this.bckPriceModel

      this.priceModel.SessionId = this.getSessionId
    },
    calculateKDV(amount) {
      return (parseFloat(amount) * 0.18).toFixed(2)
    },
    calculateTotal(amount) {
      return (parseFloat(amount) * 1.18).toFixed(2)
    },
    parseUpdated(updated) {
      return moment(updated).format("DD.MM.YYYY")
    }
  },
  mounted() {
    moment.locale('tr')
    this.getPrices()
  }
}
</script>

<style scoped>
  
  .table { font-size: 1rem; }

  .bg-primary-dark {
    background-color: #F7F7F7;
  }

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/components/SarfMalzemeleriPage.vue